<dx-popup
    #historyPopup
    minWidth="150px"
    minHeight="150px"
    width="55%"
    height="55%"
    title="Vendor Account History"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onHidden)="onHistoryPopUpClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box #history width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <div class="property-container">
                    <dx-box width="100%" height="100%" direction="row">
                        <dxi-item baseSize="auto">
                            <div class="row-container">
                                <div class="row-label">Community:</div>
                                <div class="row-value">{{ communityName }}</div>
                            </div>
                        </dxi-item>

                        <dxi-item baseSize="auto">
                            <div class="row-container">
                                <div class="row-label">Vendor:</div>
                                <div class="row-value">{{ vendorName }}</div>
                            </div>
                        </dxi-item>

                        <dxi-item baseSize="auto">
                            <div class="row-container">
                                <div class="row-label">Account #:</div>
                                <div class="row-value">{{ vendorAccountNumber }}</div>
                            </div>
                        </dxi-item>

                        <dxi-item [ratio]="1">
                            <div class="row-end-container">
                                <dx-button
                                    text="Refresh Logs"
                                    icon="refresh"
                                    type="default"
                                    (onClick)="onRefreshLogsClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-box>
                </div>
            </dxi-item>

            <dxi-item [ratio]="1" [visible]="!hasGridSourceData">
                <div *dxTemplate>
                    <div *ngIf="!hasGridSourceData" class="no-data-container">
                        <span [innerHTML]="noDataText"></span>
                    </div>
                </div>
            </dxi-item>

            <dxi-item [ratio]="1" [visible]="hasGridSourceData">
                <div *dxTemplate>
                    <dx-data-grid
                        *ngIf="hasGridSourceData"
                        width="100%"
                        height="100%"
                        [dataSource]="source"
                        [showBorders]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [hoverStateEnabled]="true"
                        [columnAutoWidth]="true"
                    >
                        <dxo-selection mode="single"></dxo-selection>
                        <dxo-sorting mode="multiple"></dxo-sorting>
                        <dxo-paging [pageSize]="10"></dxo-paging>
                        <dxo-pager
                            [showPageSizeSelector]="true"
                            [allowedPageSizes]="[]"
                            [showNavigationButtons]="true"
                            [showPageSizeSelector]="false"
                            [showInfo]="true"
                        ></dxo-pager>
                        <dxi-column
                            dataField="actionedOn"
                            caption="Actioned On"
                            dataType="date"
                            sortOrder="desc"
                            [format]="dateFormat"
                            [showInColumnChooser]="false"
                            [allowGrouping]="false"
                        ></dxi-column>
                        <dxi-column dataField="user.displayName" caption="User" sortOrder="desc"></dxi-column>
                        <dxi-column dataField="action" caption="Action" dataType="string"></dxi-column>
                        <dxi-column dataField="beginValue" caption="Begin" dataType="string"></dxi-column>
                        <dxi-column dataField="endValue" caption="End" dataType="string"></dxi-column>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="button-container">
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    [icon]="iconClose"
                                    (onClick)="onHistoryPopUpClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#history' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
